import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiProviderService {

    static getApiHeaders() {
        return new HttpHeaders().set('Content-Type', 'application/json');
    }

    constructor(public http: HttpClient) {}

    submitContactUsDetails(postData) {
        const headers = ApiProviderService.getApiHeaders();
        return this.http.post('https://r50zfry0p3.execute-api.us-east-2.amazonaws.com/default/smtp-email', postData, {headers: headers});
    }
}
